import { InvoiceLineColumn } from '@features/invoices/types/invoiceLineColumn'

export const getInvoiceColumnVisibilityFormDefaultValues = (predefinedValues?: InvoiceLineColumn[]) => {
  return {
    selectedColumns: predefinedValues || [],
  }
}
